"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _commonFns = /*#__PURE__*/ _interop_require_default(require("./commonFns"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const databricks = _extends({}, _commonFns.default, {
    AND: async (args)=>{
        return {
            builder: args.knex.raw(`CASE WHEN ${args.knex.raw(`${(await Promise.all(args.pt.arguments.map(async (ar)=>(await args.fn(ar, '', 'AND')).builder.toQuery()))).join(' AND ')}`).wrap('(', ')').toQuery()} THEN TRUE ELSE FALSE END`)
        };
    },
    OR: async (args)=>{
        return {
            builder: args.knex.raw(`CASE WHEN ${args.knex.raw(`${(await Promise.all(args.pt.arguments.map(async (ar)=>(await args.fn(ar, '', 'OR')).builder.toQuery()))).join(' OR ')}`).wrap('(', ')').toQuery()} THEN TRUE ELSE FALSE END`)
        };
    }
});
const _default = databricks;
